import { useEffect } from "react";
import {
  Accordion
} from "react-bootstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import SingleRecommendation from "./Components/SingleFullscriptRecommendation";
import AppDateRangePicker from "components/AppDateRangePicker/Index";


const FullscriptRecommendations = ({
  dispatch,
  fullscriptConnection,
  fullscriptRecommendations,
  getFullscriptRecommendations,
  getRecommendationDetails,
  fullScriptCountry,
}) => {
  // const [fullscriptRecommendations, setFullscriptRecommendations] = useState(null);
  const { clientId } = useParams();

  
  useEffect(() => {
    if(fullscriptConnection) {
      getFullscriptRecommendations();
    }
  }, [fullscriptConnection]);

  return (
    <div className="mt-4 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-bold">
          Fullscript Recommendations
        </h6>
        <div>
          <AppDateRangePicker
            isClearable={true}
            onChange={getFullscriptRecommendations}
          />
        </div>
      </div>
      <Accordion className="ColoredAcorrdion">
        {fullscriptRecommendations?.length > 0 ? (
          fullscriptRecommendations.map(recommendation => {
            return (
              <SingleRecommendation
                key={recommendation.id}
                recommendation={recommendation}
                getDetails={getRecommendationDetails}
                getRecommendations={getFullscriptRecommendations}
                fullScriptCountry={fullScriptCountry}
              />
            )
          })
        ):(
          <p>No Fullscript recommendations found</p>
        )}
      </Accordion>
    </div>
  )
}



const mapStateToPros = (state) => {
  let fullscriptConnection = state.AccountSetting.integrations.find(integration => integration.connection_type == "full_script");
  return {
    fullscriptConnection,
    fullscriptRecommendations: state.Client.client.fullscriptRecommendations,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(FullscriptRecommendations);